import MtnZAService from "@/services/mtnZAService";

export const brandConfigObjectMap = new Map();

export const Brands = {
    VodacomSouthAfricaEnglish: 'vc-za-en',
    VodacomSouthAfricaEnglishDemo: 'vc-za-en-demo',
    EtisalatPakistanEnglish: 'et-pk-en',
    VodacomEvinaSouthAfricaEnglish: 'vc-encrypt-za-en',
    MtnSouthAfricaEnglish: 'mtn-za-en',
    TelkomWorldPlaySouthAfticaEnglish: 'telkom-wp-za-en',
    MTNWorldPlaySouthAfticaEnglish: 'mtn-wp-za-en',
    WorldPlaySouthAfticaEnglish: 'wp-za-en',
    GrameenphoneBangladeshEnglish: 'gp-bd-en',
    productId: 26,
};

brandConfigObjectMap.set(Brands.VodacomSouthAfricaEnglish, {
    gameTitle: 'Cricket Zone',
    freePlayServiceId: 'cricket-free',
    baseRoute: '/home',
    productId: 26,
    hasBracketGames: true
});
brandConfigObjectMap.set(Brands.VodacomSouthAfricaEnglishDemo, {
    gameTitle: 'Cricket Zone',
    freePlayServiceId: 'cricket-free',
    baseRoute: '/home',
    productId: 26,
    demoMsisdn: '27844696041',
    hasBracketGames: true
});

brandConfigObjectMap.set(Brands.EtisalatPakistanEnglish, {
    gameTitle: 'Cricket Zone',
    freePlayServiceId: 'cricket-free',
    baseRoute: '/home',
    productId: 26,
    hasBracketGames: false,
});

brandConfigObjectMap.set(Brands.MtnSouthAfricaEnglish, {
    gameTitle: 'Cricket Zone',
    freePlayServiceId: 'cricket-free',
    baseRoute: '/home',
    productId: 55,
    hasBracketGames: false,
});

brandConfigObjectMap.set(Brands.MTNWorldPlaySouthAfticaEnglish, {
    gameTitle: 'Cricket Zone World Play',
    freePlayServiceId: 'cricket-free',
    baseRoute: '/home',
    productId: 55,
    serviceClass: MtnZAService,
    hasBracketGames: false,
});

brandConfigObjectMap.set(Brands.TelkomWorldPlaySouthAfticaEnglish, {
    gameTitle: 'Cricket Zone World Play',
    freePlayServiceId: 'cricket-free',
    baseRoute: '/home',
    productId: 58,
    hasBracketGames: false,
    // TODO: Need Telkom binds for a service here...
});

brandConfigObjectMap.set(Brands.WorldPlaySouthAfticaEnglish, {
    gameTitle: 'Cricket Zone World Play',
    freePlayServiceId: 'cricket-free',
    baseRoute: '/home',
    productId: 55,
    serviceClass: MtnZAService,
    hasBracketGames: false,
});

brandConfigObjectMap.set(Brands.GrameenphoneBangladeshEnglish, {
    gameTitle: 'Cricket Zone',
    freePlayServiceId: 'cricket-free',
    baseRoute: '/home',
    hasBracketGames: false,
    productId: 82
});
